import { get } from 'lodash';
import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { getModal } from '../modals/framework/store/modal-selectors';

export const getPostSettingsModalProps = (state) =>
  get(getModal(state, MODAL_TYPE_POST_SETTINGS), 'props', {});
